import Show from "./Show";
// import Create from './Create';
// import List from './List';
// import Edit from './Edit';
export { Show };
export default { Show };
